import { render, staticRenderFns } from "./signfor-logitics-statistical-list.vue?vue&type=template&id=28a3d86c&scoped=true&"
import script from "./signfor-logitics-statistical-list.vue?vue&type=script&lang=ts&"
export * from "./signfor-logitics-statistical-list.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28a3d86c",
  null
  
)

export default component.exports